class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updateURL();
    this.updateVariantInput();
    this.updateMedia();
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    const variant = this.getVariantFromOptions();
    if (variant) this.currentVariant = variant;
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;
    const newMediaId = this.currentVariant.featured_media.id;
    const mediaToHide = document.querySelectorAll(`[data-media-id]:not([data-media-id="${newMediaId}"])`);
    const mediaToShow = document.querySelectorAll(`[data-media-id="${newMediaId}"]`);

    mediaToHide.forEach((media) => media.classList.add('hidden'));
    mediaToShow.forEach((media) => media.classList.remove('hidden'));
  }

  updateVariantInput() {
    const input = document.querySelector(`input[name="id"]`);
    input.value = this.currentVariant.id;
  }

  getVariantFromOptions() {
    const form = this.querySelector('form');
    const variants = JSON.parse(form.dataset.variants || "[]");
    return variants.find((variant) =>
      !variant.options.map((opt, i) => this.options[i] !== opt).includes(true)
    );
  }
}

customElements.define('variant-selects', VariantSelects);
